import type { CommentThread, NoteTarget, Frame } from './types';
import type { Pt, RectLookup } from '../chrome/noteTarget';

let threadSeq = 0;
let msgSeq = 0;
export const genCommentId = (): string => `cmt_${Date.now()}_${threadSeq++}`;
export const genMsgId = (): string => `cmsg_${Date.now()}_${msgSeq++}`;

export function openThreads(threads: CommentThread[]): CommentThread[] {
  return threads.filter((t) => !t.resolved);
}

/** Threads anchored to a given frame (element or frame target). */
export function threadsForFrame(threads: CommentThread[], frameId: string): CommentThread[] {
  return threads.filter(
    (t) =>
      (t.target.kind === 'element' || t.target.kind === 'frame') && t.target.frameId === frameId,
  );
}

/** Compact human/agent-readable location of a comment anchor. */
export function describeCommentTarget(target: NoteTarget): string {
  if (target.kind === 'element') return `${target.frameId}#${target.nodeId}`;
  if (target.kind === 'frame') return `frame ${target.frameId}`;
  return `pin ${target.x},${target.y}`;
}

/** World-space point for a comment pin. Mirrors noteTargetPoint but takes a raw target. */
export function commentTargetPoint(
  target: NoteTarget,
  byId: Map<string, Frame>,
  rectLookup: RectLookup,
): Pt | null {
  if (target.kind === 'pin') return { x: target.x, y: target.y };
  if (target.kind === 'frame') {
    const f = byId.get(target.frameId);
    return f ? { x: f.x + f.w / 2, y: f.y + (f.h ?? 80) / 2 } : null;
  }
  const r = rectLookup(target.frameId, target.nodeId);
  if (r) return { x: r.x + r.w / 2, y: r.y + r.h / 2 };
  const f = byId.get(target.frameId);
  return f ? { x: f.x + f.w / 2, y: f.y + (f.h ?? 80) / 2 } : null;
}
